// Paleta de datos de marca Y2D (arranca en los colores de marca; los últimos son
// tonos derivados + un gris neutro para "Otros"/series de relleno). Regla: idealmente
// mostrar máximo 6 series + "Otros" agregado en gris, no 40 colores genéricos.
const colors = [
  '#5575DF', // blue (primary)
  '#19BFA7', // teal (secondary)
  '#FF7D6A', // coral (accent)
  '#F5A623', // ámbar (warning)
  '#7C93E8', // blue 300
  '#5CD3C1', // teal 300
  '#1B2E38', // petróleo
  '#B9C4CC', // gris neutro ("Otros")
  // Relleno tonal por si hay muchas series (mantiene la familia de marca)
  '#A9B9F0',
  '#9EE0D5',
  '#FFB3A6',
  '#F7C877',
  '#42589C',
  '#0E8C79',
  '#C7563F',
  '#B27B1B',
]
export default {
  colors
}